// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zvJC5RMOSSjfi9 {
  padding: 10px;
}
.zvJC5RMOSSjfi9 .SaPSAvkQQCFtTk {
  font-weight: var(--ds-font-weight-regular, 400);
}
.zvJC5RMOSSjfi9 .u5v9OnhUcq3JWF {
  margin-top: 40px;
  color: var(--ds-text, #172b4d);
  font-size: 24px;
  letter-spacing: -0.01em;
  line-height: 28px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin-top: 25px;
}
.zvJC5RMOSSjfi9 .ziK4qk0D9haC8_ {
  font-weight: var(--ds-font-weight-regular, 400);
  display: flex;
  align-items: center;
  min-height: 64px;
  color: var(--ds-text, #172b4d);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.zvJC5RMOSSjfi9 .zpVgbtzPQL_bqQ {
  margin-top: 52px;
  color: var(--ds-text, #172b4d);
  font-size: 35px;
  letter-spacing: -0.01em;
  line-height: 40px;
  font-weight: var(--ds-font-weight-semibold, 600);
  overflow-wrap: break-word;
  font-size: 26px;
}
.zvJC5RMOSSjfi9 .i9BXc6UHlmUvFr,
.zvJC5RMOSSjfi9 .HpMW3W037WDbOC,
.zvJC5RMOSSjfi9 .ilvp1dNLmB0PkO {
  font-weight: var(--ds-font-weight-regular, 400);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.zvJC5RMOSSjfi9 .HpMW3W037WDbOC {
  margin: 32px 25px 25px 30px;
}
.zvJC5RMOSSjfi9:nth-last-child(2) {
  border-top: 3px solid var(--ds-border-discovery, #8270db);
  border-right: 4px solid var(--ds-border-discovery, #8270db);
  border-left: 3px solid var(--ds-border-discovery, #8270db);
}
.zvJC5RMOSSjfi9:nth-last-child(2) .u5v9OnhUcq3JWF {
  margin-top: 3px;
}
.zvJC5RMOSSjfi9:nth-last-child(2)::before {
  margin-top: 20px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  font-weight: var(--ds-font-weight-semibold, 600);
  content: attr(data-value);
  position: relative;
  top: -15px;
  width: 85px;
  height: 24px;
  padding: 5px;
  border-radius: 2px;
  background-color: var(--ds-border-discovery, #8270db);
  color: var(--ds-text-inverse, #ffffff);
  line-height: inherit;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"planCell": `zvJC5RMOSSjfi9`,
	"purchase": `SaPSAvkQQCFtTk`,
	"name": `u5v9OnhUcq3JWF`,
	"info": `ziK4qk0D9haC8_`,
	"price": `zpVgbtzPQL_bqQ`,
	"frequency": `i9BXc6UHlmUvFr`,
	"pricingVaries": `HpMW3W037WDbOC`,
	"currentPlan": `ilvp1dNLmB0PkO`
};
export default ___CSS_LOADER_EXPORT___;
